//Theme Scripts

// Fixed navigation

document.addEventListener('DOMContentLoaded', function() {
  const navbar = document.querySelector(".fixed");

  // Suoritetaan vain jos fixed-elementti löytyy
  if (navbar) {
    let prevScrollPos = window.scrollY;
    const scrollThreshold = 800;
    const colorThreshold = 1;

    window.onscroll = function() {
      let currentScrollPos = window.scrollY;

      if (prevScrollPos > currentScrollPos || currentScrollPos < scrollThreshold) {
        navbar.style.top = "0";
      } else {
        navbar.style.top = `-${navbar.offsetHeight}px`;
      }

      if (currentScrollPos >= colorThreshold) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }

      
      prevScrollPos = currentScrollPos;
    };
  }
});

jQuery(document).ready(function($) {

    // Burgeri auki
    $('.custom-page-list .menu-pagelist-brgr').on('click', function() {
        $('.custom-page-list .wp-block-page-list').show();
        $('.custom-page-list .menu-pagelist-close').show();
        $(this).hide();
    });

    // Sulje nappi
    $('.custom-page-list .menu-pagelist-close').on('click', function() {
        $('.custom-page-list .wp-block-page-list').hide();
        $('.custom-page-list .menu-pagelist-brgr').show();
        $(this).hide();
    });
});

jQuery(function ($) {
  var $columns = $('.subpage-list').closest('.wp-block-columns');
  if (!$columns.length) return;

  var mq = window.matchMedia('(max-width: 781px)');

  function toggleReverse(e) {
    $columns.toggleClass('reverse-columns', e.matches);
  }

  toggleReverse(mq);                          // sivunlataus
  mq.addEventListener('change', toggleReverse); // ikkunan koon muutos
});